import React, { useEffect, useRef } from "react";
import "./ConfirmToast.scss";

const ConfirmToast = ({
  actionType,
  message,
  onConfirm,
  onCancel,
  payload,
  customContent,
}: any) => {
  const toastRef = useRef<HTMLDivElement | null>(null);

  const toastInstanceRef = useRef<any>(null);

  // show method for parent via event
  useEffect(() => {
    const showToast = () => {
      if (!toastInstanceRef.current && toastRef.current) {
        toastInstanceRef.current = new window.bootstrap.Toast(
          toastRef.current,
          { autohide: false }
        );
      }
      toastInstanceRef.current?.show();
    };

    window.addEventListener(`show-${actionType}-toast`, showToast);
    return () =>
      window.removeEventListener(`show-${actionType}-toast`, showToast);
  }, [actionType]);

  useEffect(() => {
    const el = toastRef.current;
    const cleanup = () => {
      toastInstanceRef.current = null;
    };
    el?.addEventListener("hidden.bs.toast", cleanup);
    return () => el?.removeEventListener("hidden.bs.toast", cleanup);
  }, []);

  return (
    <div
      ref={toastRef}
      className="toast position-fixed top-0 end-0 m-3"
      id={`${actionType}ConfirmToast`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div
        className={`toast-header bg-${
          actionType === "delete" ? "danger" : "primary"
        } text-white`}
      >
        <strong className="me-auto">
          {actionType === "delete" ? "Confirm Deletion" : "Confirm Replacement"}
        </strong>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="toast"
          aria-label="Close"
          onClick={onCancel}
        />
      </div>
      <div className="toast-body">
        {message}

        {customContent && <div className="mt-3">{customContent}</div>}

        <div className="mt-2 pt-2 border-top d-flex justify-content-end gap-2">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            data-bs-dismiss="toast"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`btn btn-sm btn-${
              actionType === "delete" ? "danger" : "primary"
            }`}
            data-bs-dismiss="toast"
            onClick={() => onConfirm(payload)}
          >
            {actionType === "delete" ? "Delete" : "Replace"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmToast;
